var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9377_79238)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 0H24.75V24H0.75V0Z",
    fill: "#E30A17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1002 12.375C17.1002 15.6843 14.3674 18.3703 11.0018 18.3703C7.63613 18.3703 4.90332 15.6843 4.90332 12.3703C4.90332 9.0562 7.63145 6.37964 10.9971 6.37964C14.3627 6.37964 17.1049 9.06089 17.1049 12.375H17.1002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4051 12.3749C17.4051 15.0233 15.2207 17.1702 12.5254 17.1702C9.83008 17.1702 7.65039 15.0233 7.65039 12.3749C7.65039 9.72646 9.83008 7.57959 12.5254 7.57959C15.2207 7.57959 17.4004 9.72646 17.4004 12.3749H17.4051Z",
    fill: "#E30A17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2857 9.5719L18.2389 11.7891L16.167 12.3516L18.2061 13.0781L18.1592 15.1078L19.4857 13.5235L21.4967 14.2172L20.3342 12.5156L21.7498 10.8235L19.5748 11.4235L18.2857 9.5719Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9377_79238"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/tr.539136a2622832b7bd73c721dc10359f.svg";
export { ForwardRef as ReactComponent };